import React from 'react';

import Modal from "../../../../component/modal/ModalTemplate";
import './PackageTermsModal.css'

class PackageHistoryTermsModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        }
    }// end constructor

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.loading !== nextState.loading
            || this.props.isOpen !== nextProps.isOpen
        )
    }

    render() {
        const { isOpen, handleClose } = this.props;

        return (
            <Modal
                open={isOpen}
                handleClose={handleClose}
                modalTitle={"결제 약관"}
                className={"react-modal"}
            >
                {/* 약관 영역 */}
                <div className="modal-body p-3">
                    <textarea
                        className="terms-textarea"
                        readOnly
                    >
{`비즈팅 패키지 상품 특별 이용약관

본 약관은 비즈톡 주식회사(이하 "회사")가 제공하는 비즈팅 서비스 내
패키지형 문자 발송 상품(이하 “본 상품”)에 한하여 적용되며,
비즈팅 일반 이용약관과 별도로 운영됩니다.

제1조 (목적)
본 약관은 비즈팅 서비스에서 판매하는 패키지형 상품의
구매, 이용 조건, 유효기간, 환불 및 소멸 규정 등을 명확히 함으로써,
이용자와 회사 간 권리 및 의무를 정의하는 것을 목적으로 합니다.

제2조 (용어의 정의)
1. 본 상품: 회사가 제공하는 패키지형 문자 발송 상품으로,
   특정 건수의 문자 발송 포인트를 정해진 단위(예: 1회당 발송량)로
   분할 사용할 수 있도록 구성된 선불형 상품을 의미합니다.
2. 1회차 등록일: 이용자가 해당 패키지 상품으로 최초 발송을 실행한 날짜를 말합니다.
3. 1회차 검수 요청일: 이용자가 해당 패키지 상품으로 최초 발송 건을 검수 요청한 날짜를 말합니다.
4. 유효기간: ‘결제일’을 기준으로 계산하며, 유효기간 30일 경과 시
   환불 신청이 불가하며, 미사용 회차 및 잔여 포인트는 자동 소멸됩니다.
5. 만료기한: ‘결제일’을 기준으로 계산하며, 만료기한 90일 경과 시
   환불 신청이 불가하며, 미사용 회차 및 잔여 포인트는 자동 소멸됩니다.
6. 환급: 발송 희망 건수에 미달한 잔여 포인트 중
   일반 포인트로 자동 전환되는 부분을 말합니다.

제3조 (상품 구성 및 이용 조건)
1. 본 상품은 회사가 정한 총 발송 건수를
   정해진 단위(회차별 발송량)로 분할하여 사용하는 방식입니다.
   (예: 총 3,000건 / 500건씩 × 6회)
2. 각 상품의 구성과 조건은 상품 상세페이지에 별도 고지됩니다.
3. 캠페인 등록 유효기간은 결제일로부터 30일입니다.
4. 상품 구매 후 조건 변경은 불가합니다.
5. 목표 발송 건수 미달 시 잔여 포인트는
   패키지 포인트로 복구 후 최종 회차 집행 이후
   일반 포인트로 환급됩니다.

제4조 (환불 및 전환 규정)
1. 다음 조건을 충족한 경우 환불 신청이 가능합니다.
   1) 유효기간 내 캠페인 등록이 없는 경우
   2) 모든 회차 등록 후 발송 이력이 있는 경우
   3) 모든 회차 취소 시 만료기한 이내
   4) 1회차가 SKT 승인 완료 전 상태에서 취소한 경우
2. 환불 시 PG 수수료 및 송금 수수료가 차감됩니다.
3. 일반 포인트 전환은 약관에 명시된 경우에만 가능합니다.

제5조 (기타)
1. 본 약관은 비즈팅 일반 이용약관에 우선합니다.
2. 회사는 사전 고지 후 약관을 변경할 수 있습니다.
3. 본 상품은 프로모션 상품으로 판매가 종료될 수 있습니다.
4. 구매 시 본 약관에 동의한 것으로 간주합니다.
5. 본 약관에 명시되지 않은 사항은 일반 이용약관을 따릅니다.`}
                    </textarea>

                </div>
            </Modal>
        )
    }
}


export default PackageHistoryTermsModal;
